

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BookingsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Bookings {
    id?: number;
    name: string;
    
  parameters?: BookingsParameter[];
  links?: any;
}

export abstract class BookingData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Bookings[]>;
  abstract create(url: string,data: Bookings): Observable<any>;
  abstract update(url: string,data: Bookings): Observable<any>;
  abstract delete(url: string): Observable<any>;
}